var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[`${_vm.$appPrefix}-scroll-indicator`]},[_c('a',{attrs:{"href":"#"},on:{"click":_vm.onClick}},[_c('div',[_c('MgsIcon',{attrs:{"name":_vm.$icons.ARROW_DOWN,"size":"xl"}}),_c('MgsIcon',{attrs:{"name":_vm.$icons.ARROW_DOWN,"size":"xl"}})],1),_vm._t("title")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }